import { Link } from "react-router-dom";
import { t } from "i18next";
import localizedLink from "../utils/localizedLink";
import useLanguage from "../hooks/useLanguage";

export default function NotFound() {
    const { language } = useLanguage()
    return (
        <div className="mt-5 text-center">
            <h2 className="text-2xl font-medium">{t("404")}</h2>
            <Link to={localizedLink('/', language)} className="mt-3 btn btn-dark eufy-button">
                {t("cart.home")}
            </Link>
        </div>
    );
}